import { OAuthModuleConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';
export const authModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: [
      environment.apiAuthUrl,
      environment.apiVenuesUrl,
      environment.contentdistribution.private.url,
      environment.apiSeatingChartViewer.api,
      environment.sitesBuilder.api,
      environment.editor2dmaps.api,
      environment.apiContentUploaderUrl,
      environment.amenityManagementSystem.url,
      environment.billing.url,
    ],
    sendAccessToken: true,
  },
};
